import React from 'react';
import PropTypes from 'prop-types';
import { useApplication } from 'hooks/use_application';

const ByLocale = ({ attribute, object }) => {
  const { getAttribute } = useApplication();
  return getAttribute(object, attribute) || null;
};

ByLocale.propTypes = {
  attribute: PropTypes.string.isRequired,
  object: PropTypes.object.isRequired,
};

export default ByLocale;
